class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedMap = new Map();
    this.focusElement = this.input;
    this.resetButton.addEventListener('click', this.clear.bind(this));
    this.input.addEventListener('input', FoxTheme.utils.debounce(this.onChange.bind(this), 300));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.input.addEventListener('blur', this.kgOnBlur.bind(this));
    this.searchContent = this.querySelector('.search__content');
    this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';
    this.header = document.querySelector('header');
    this.toggleNavigationButton = document.querySelector('.toggle-navigation-button');
    this.togglePanelButton = document.getElementById('OpenSearchPanelButton');
    this.formResetButton = document.getElementById('FormResetButton');
    this.isOpen = false;

    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener('click', this.boundHandleClickOutside);
    this.searchProductTypes?.addEventListener('change', this.handleProductTypeChange.bind(this));

    this.isHeaderSearch = this.closest('header') !== null;

    document.addEventListener('menu-drawer:open', () => {
      this.classList.remove('predictive-search-open');
      document.body.classList.remove('search-open');
    });

    this.states = {
      OPEN: 'predictive-search-open',
      LOADING: 'btn--loading',
      SEARCH_OPEN: 'search-open',
    };

    if (this.formResetButton) {
      this.formResetButton.addEventListener('click', () => {
        this.toggleSearchState(false);
        this.searchContent.classList.add('hidden');
        this.open = false;
      });
    }

    
    if (this.togglePanelButton) {
      this.togglePanelButton.addEventListener('click', () => {       
        if (!this.open) {
          this.toggleSearchState();
          this.searchContent?.classList.remove('hidden');
          this.open = true;
        } else {
            this.toggleSearchState(false);
            this.searchContent.classList.add('hidden');
            this.open = false;
        }
      });
    }
  }

  get input() {
    return this.querySelector('input[type="search"]');
  }
  get resetButton() {
    return this.querySelector('button[type="reset"]');
  }

  get searchProductTypes() {
    return this.querySelector('#SearchProductTypes');
  }

  kgOnBlur(event) {
    this.classList.remove('kg-predictive-search-open');
  }
  
  onFocus(event) {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom)}px`
    );
    if (this.isHeaderSearch && !this.searchRecommendationEmpty) {
      document.body.classList.add('search-open');
      this.toggleNavButtonVisibility(false);
    }

    if (!this.searchRecommendationEmpty) {
      this.searchContent.classList.remove('hidden');
    }
    this.classList.add('predictive-search-open');
    // if (this.getQuery().length === 0) {
    //   if (this.searchRecommendationEmpty) {
    //     this.searchContent.classList.add('hidden');
    //   }
    //   return;
    // }
    const url = this.setupURL().toString();
    this.renderSection(url, event);
    this.classList.add('kg-predictive-search-open');
  }

  getQuery() {
    return this.input.value.trim();
  }

  clear(event = null) {
    event?.preventDefault();
    this.input.value = '';
    this.input.focus();
    this.removeAttribute('results');
    this.toggleSearchState(false);
  }

  handleProductTypeChange(evt) {
    const query = this.getQuery();
    if (query.length > 0) {
      const url = this.setupURL().toString();
      this.renderSection(url);
    }
  }

  setupURL() {
    const url = new URL(`${window.shopUrl}${FoxTheme.routes.predictive_search_url}`);
    const targetSectionId = FoxTheme.utils.getSectionId(this);
    const ajaxSectionId = this.dataset.ajaxSectionId || targetSectionId;
    let search_term = this.getQuery();
    if (this.searchProductTypes && this.searchProductTypes.value != '') {
      search_term = `product_type:${this.searchProductTypes.value} AND ${encodeURIComponent(search_term)}`;
    }
    return (
      url.searchParams.set('q', search_term),
      url.searchParams.set('resources[limit]', this.dataset.resultsLimit || 3),
      url.searchParams.set('resources[limit_scope]', 'each'),
      url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,variants.sku,tag'),
      url.searchParams.set('section_id', ajaxSectionId),
      url
    );
  }

  onChange() {
    // if (this.getQuery().length === 0) {
    //   this.clear();
    //   return;
    // }
    const url = this.setupURL().toString();
    this.renderSection(url);
  }

  renderSection(url) {
    this.cachedMap.has(url) ? this.renderSectionFromCache(url) : this.renderSectionFromFetch(url);
  }

  renderSectionFromCache(url) {
    const responseText = this.cachedMap.get(url);
    this.renderSearchResults(responseText), this.setAttribute('results', '');
  }

  renderSectionFromFetch(url) {
    this.setLoadingState(true);

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then((responseText) => {
        this.renderSearchResults(responseText);
        this.cachedMap.set(url, responseText);
      })
      .catch((error) => {
        console.error('Error fetching data: ', error);
        this.setAttribute('error', 'Failed to load data');
      })
      .finally(() => this.setLoadingState(false));
  }
  // renderSearchResults(responseText) {
  //   const sectionId = FoxTheme.utils.getSectionId(this);
  //   const targetId = 'PredictiveSearchResults-' + sectionId;
  //   const responseId = this.dataset.ajaxSectionId ? 'PredictiveSearchResults-' + this.dataset.ajaxSectionId : targetId;
  //   const targetElement = document.getElementById(targetId);

  //   if (targetElement) {
  //     const parser = new DOMParser();
  //     const parsedDoc = parser.parseFromString(responseText, 'text/html');
  //     const contentElement = parsedDoc.getElementById(responseId);

  //     if (contentElement) {
  //       this.searchContent?.classList.remove('hidden');
  //       targetElement.innerHTML = contentElement.innerHTML;
  //       const targetFormId = `PredictiveSearch-${sectionId}`;
  //       targetElement.querySelectorAll('[data-ajax-form-submit]').forEach((button) => {
  //         button.setAttribute('form', targetFormId);
  //       });

  //       if (this.isHeaderSearch && !document.body.classList.contains('search-open')) {
  //         document.body.classList.add('search-open');
  //         this.toggleNavButtonVisibility(true);
  //         this.classList.add('predictive-search-open');
  //       } else {
  //         this.classList.add('predictive-search-open');
  //       }
  //     } else {
  //       console.error(`Element with id '${id}' not found in the parsed response.`);
  //     }
  //   } else {
  //     console.error(`Element with id '${id}' not found in the document.`);
  //   }
  // }
 renderSearchResults(responseText) {
    // Find the form with kg-main-search-class within the current search instance
    const searchForm = this.querySelector('.kg-main-search-class');
    
    if (!searchForm) {
      console.error(`Form with class 'kg-main-search-class' not found in the current search instance.`);
      return;
    }

    // Find the results container within the current search instance
    // It should be a sibling or within the same parent structure
    const targetElement = this.querySelector('.search__results')?.querySelector('[role="listbox"]') || 
                          this.querySelector('[role="listbox"]');

    if (targetElement) {
      const parser = new DOMParser();
      const parsedDoc = parser.parseFromString(responseText, 'text/html');
      
      // Find the results container in the parsed response using the same approach
      const contentElement = parsedDoc.querySelector('[role="listbox"]');

      if (contentElement) {
        this.searchContent?.classList.remove('hidden');
        targetElement.innerHTML = contentElement.innerHTML;
        
        // Get the form ID from the current search form
        const targetFormId = searchForm.id || searchForm.getAttribute('id');
        if (targetFormId) {
          targetElement.querySelectorAll('[data-ajax-form-submit]').forEach((button) => {
            button.setAttribute('form', targetFormId);
          });
        }

        if (this.isHeaderSearch && !document.body.classList.contains('search-open')) {
          document.body.classList.add('search-open');
          this.toggleNavButtonVisibility(true);
          this.classList.add('predictive-search-open');
        } else {
          this.classList.add('predictive-search-open');
        }
        if (typeof window.updateDiscountBadges === 'function') {
          console.log("Badge Updated!!!!!")
          window.updateDiscountBadges();
        }
      } else {
        console.error(`Results container with role 'listbox' not found in the parsed response.`);
      }
    } else {
      console.error(`Results container with role 'listbox' not found in the current search instance.`);
    }
  }
  handleClickOutside(event) {
    const target = event.target;
    const shouldClose = this.isHeaderSearch
      ? !this.contains(target) &&
        ((target.classList.contains('fixed-overlay') && target.closest('.header-section')) ||
          target.classList.contains('header__search-close'))
      : !this.contains(target);

    if (shouldClose) {
      setTimeout(() => this.toggleSearchState(false));
    }
  }

  toggleSearchState(isOpen) {
    this.classList.toggle(this.states.OPEN, isOpen);
    if (this.isHeaderSearch) {
      document.body.classList.toggle(this.states.SEARCH_OPEN, isOpen);
      this.toggleNavButtonVisibility(!isOpen);
    }
    if (!isOpen && this.searchRecommendationEmpty) {
      this.searchContent?.classList.add('hidden');
    }
  }

  toggleNavButtonVisibility(isOpen) {
    this.toggleNavigationButton && this.toggleNavigationButton.classList.toggle('is-show', isOpen);
  }

  setLoadingState(isLoading) {
    if (isLoading) {
      this.setAttribute('loading', 'true');
      this.resetButton.classList.add(this.states.LOADING);
    } else {
      this.removeAttribute('loading');
      this.resetButton.classList.remove(this.states.LOADING);
      this.setAttribute('results', 'true');
    }
  }
}
customElements.define('predictive-search', PredictiveSearch);

// --- Client-side Search Page SKU Interceptor (No Backend Required) ---
document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname.includes('/search')) {
    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get('q');
    
    if (query) {
      // Check if the search page rendered 0 products (common classes in the theme)
      const hasProducts = document.querySelectorAll('.card-product, .product-card, .f-column.card').length > 0;
      
      if (!hasProducts) {
        const gridContainer = document.getElementById('ProductGridContainer');
        if (gridContainer) {
          // Render a clean loading spinner
          gridContainer.innerHTML = `
            <div class="loading-spinner-wrapper" style="text-align:center; padding: 60px 0;">
              <div class="loading-spinner" style="display:inline-block; width: 40px; height: 40px; border: 4px solid rgba(0,0,0,0.1); border-radius: 50%; border-top-color: #000; animation: spin 1s ease-in-out infinite;"></div>
              <style>@keyframes spin { to { transform: rotate(360deg); } }</style>
            </div>
          `;
          
          // Request predictive search rendering including variants.sku
          const ajaxUrl = `${window.shopUrl || ''}/search/suggest?q=${encodeURIComponent(query)}&section_id=predictive-search-ajax&resources[type]=product&resources[limit]=36&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku,tag`;
          
          fetch(ajaxUrl)
            .then(res => {
              if (!res.ok) throw new Error('Network error');
              return res.text();
            })
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const productsList = doc.getElementById('predictive-search-results-products-list');
              
              if (productsList && productsList.children.length > 0) {
                // Remove empty state class from container
                const collectionEl = document.querySelector('.collection');
                if (collectionEl) {
                  collectionEl.classList.remove('template-search--empty');
                }
                
                // Hide any manual "No result found" messages in custom-search
                const emptyMessages = document.querySelectorAll('.template-search h4, .template-search p.text-subtext, .template-search .text-center.grid');
                emptyMessages.forEach(msg => {
                  if (msg.textContent.includes('No result') || msg.textContent.includes('No results') || msg.textContent.includes('Check the spelling')) {
                    msg.style.display = 'none';
                  }
                });

                // Build the grid
                const gridDiv = document.createElement('div');
                gridDiv.id = 'ProductsList';
                gridDiv.className = 'grid-list products-list f-grid f-grid--gap-extra-small f-grid--row-gap-medium';
                gridDiv.style.cssText = '--f-columns-mobile: 2; --f-columns-md: 3; --f-columns-xl: 4;';
                
                Array.from(productsList.children).forEach(card => {
                  const colWrapper = document.createElement('div');
                  colWrapper.className = 'f-column card';
                  colWrapper.appendChild(card);
                  gridDiv.appendChild(colWrapper);
                });
                
                gridContainer.innerHTML = '';
                gridContainer.appendChild(gridDiv);
                
                // Update page header to show result count
                const countText = `${productsList.children.length} results found for "${query}"`;
                const productCountLabel = document.getElementById('ProductCount') || document.querySelector('.template-search__header h1') || document.querySelector('[data-facet-loading] p');
                if (productCountLabel) {
                  productCountLabel.textContent = countText;
                }
              } else {
                // Show standard empty state
                gridContainer.innerHTML = `
                  <div class="empty-state flex flex-col gap-3 w-full h-full text-center" style="padding: 80px 0;">
                    <h4>No results found for "${escapeHtml(query)}".</h4>
                    <p class="m-0 text-subtext">Check the spelling or use a different word or phrase.</p>
                  </div>
                `;
              }
            })
            .catch(err => {
              console.error('SKU search render error:', err);
              gridContainer.innerHTML = `
                <div class="empty-state flex flex-col gap-3 w-full h-full text-center" style="padding: 80px 0;">
                  <h4>No results found for "${escapeHtml(query)}".</h4>
                  <p class="m-0 text-subtext">Check the spelling or use a different word or phrase.</p>
                </div>
              `;
            });
        }
      }
    }
  }

  function escapeHtml(str) {
    return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  }
});
